import UIImage from 'UIComponents/image/UIImage';
import styled from 'styled-components';
export const StyledImage = styled(UIImage).withConfig({
  displayName: "Starsstyles__StyledImage",
  componentId: "sc-16vfs8n-0"
})(["position:absolute;right:-76px;top:-56px;height:105px !important;"]);
export const OuterTitleContainer = styled.div.withConfig({
  displayName: "Starsstyles__OuterTitleContainer",
  componentId: "sc-16vfs8n-1"
})(["display:flex;justify-content:center;margin-bottom:8px;"]);
export const InnerContainer = styled.div.withConfig({
  displayName: "Starsstyles__InnerContainer",
  componentId: "sc-16vfs8n-2"
})(["position:relative;"]);